import React, { useContext } from "react";
import { useLocation } from "react-router-dom";
import styled, { ThemeContext } from "styled-components";
import { getPageType } from "../../utils/PageTypeSelector";
import { Box } from "../Box";
import { Flex, FlexVertical } from "../Flex";
import { Label } from "../Label";
import { Link } from "../Link";
import { ServiceCatalogueFooterSection } from "../ServiceCatalogueFooterSection";
import { SocialIcon } from "../SocialIcon";
import { Text } from "../Text";

const FooterTitle = styled(props => <Text {...props} fontSize={16} margin={0} />)``;
const StyledLink = styled(props => <Link {...props} color="white" />)``;
const BorderFlex = styled(props => <Flex {...props} />)`
  &&& {
    box-sizing: border-box;
    flex-wrap: wrap;
  }
  > div {
    box-sizing: border-box;
  }
`;
const CopyWrapper = styled(props => (
  <Flex
    {...props}
    boxSizing="border-box"
    opacity={0.6}
    flexDirection="row-reverse"
    px={[0, 0, 15]}
    mx="auto"
    mt={4}
    width="100%"
    justifyContent={["center", "center", "center", "end"]}
    alignItems="center"
  />
))``;

export const ServiceCatalogueFooter: React.FC = () => {
  const year = new Date().getFullYear();
  const theme = useContext(ThemeContext);
  const { white } = theme.colors;
  const pageType = getPageType(useLocation().pathname);
  return (
    <Box pt={["16px", "36px", "36px", "36px"]}>
      <Flex as="footer" name="footer" bg="primary" p={["20px", "20px", "35px", 5]} minHeight={[700, 700, 400, 0]} data-testid="footer">
        <FlexVertical
          maxWidth={["100%", "100%", "100%", "100%", "1170px"]}
          width={["100%", "100%", "100%", "100%", 8 / 12]}
          mx={["auto", "auto", "auto", 0, "auto"]}
          mt={[0, 0, 4, 0]}
          flexWrap="flex"
          justifyContent={["flex-end", "flex-end", "space-between", "flex-end"]}
        >
          <BorderFlex width={["100%", "100%", "100%", 8 / 12]} justifyContent={["flex-end", "flex-end", "space-between", "flex-end"]}>
            <Box width={[1 / 2, 1 / 2, 1 / 6, 1 / 4]} px={["15px", "15px", 0]}>
              <FooterTitle color={white}>creating a new</FooterTitle>
              <FooterTitle color={white}>energy future</FooterTitle>
            </Box>
            <ServiceCatalogueFooterSection
              title="follow us"
              order={[6, 6, 0]}
              width={["100%", "100%", 1 / 5, "18%"]}
              alignItems={["center", "center", "stretch"]}
              titleMb={2}
              data-testid="social-column"
            >
              <div>
                <SocialIcon social="facebook" />
                <SocialIcon social="twitter" />
                <SocialIcon social="linkedin" />
              </div>
            </ServiceCatalogueFooterSection>
            <ServiceCatalogueFooterSection title="legal">
              <StyledLink href="https://www.vector.co.nz/privacy-policy" aria-label="Privacy Policy">
                privacy policy
              </StyledLink>
              <StyledLink href="https://www.vector.co.nz/terms-of-use" aria-label="Terms of Use">
                terms of use
              </StyledLink>
            </ServiceCatalogueFooterSection>
            <ServiceCatalogueFooterSection title="quick links">
              <StyledLink href={`https://www.vector.co.nz/${pageType}/help-safety/in-an-emergency`} aria-label="In an Emergency">
                emergency
              </StyledLink>
              <StyledLink href="https://www.vector.co.nz/contact-us" aria-label="Contact Us">
                contact
              </StyledLink>
              <StyledLink href="https://www.vector.co.nz/personal/outages-faults" aria-label="Outages">
                outages
              </StyledLink>
              <StyledLink href="https://www.vector.co.nz/pay-now" aria-label="Pay Now">
                pay now
              </StyledLink>
              <StyledLink href="https://www.vector.co.nz/information-for-suppliers" aria-label="Information for Suppliers">
                info for suppliers
              </StyledLink>
            </ServiceCatalogueFooterSection>
            <ServiceCatalogueFooterSection title="vector sites">
              <StyledLink href="http://www.ongas.co.nz/" aria-label="OnGas">
                ongas
              </StyledLink>
              <StyledLink href="https://www.vector.co.nz/about-us/careers" aria-label="Careers">
                careers
              </StyledLink>
              <StyledLink href="https://data.vector.co.nz/" aria-label="Open Data">
                open data
              </StyledLink>
            </ServiceCatalogueFooterSection>
          </BorderFlex>

          <CopyWrapper>
            <Label color={white} fontSize={0}>
              {/* eslint-disable-next-line react/jsx-one-expression-per-line */}
              &copy; {year} Vector Ltd
            </Label>
          </CopyWrapper>
        </FlexVertical>
      </Flex>
    </Box>
  );
};
